import React, { useState } from 'react'
import { Popup } from 'antd-mobile-v5'
import { useDispatch, useSelector } from 'react-redux'
import { useBindingEcards, useCancelBindingEcards, useGetVipEcardsReplacementOptions } from '../../../services/hooks'
import { getCardFaceImageUrl } from '../../../services/utilities'
import Tag from './ChanghuanTag'
import { showToast } from '../../../components/common/tools'
import { getEcards, getProfile, getUserInfo } from '../../../reducers/selectors'
import { changeEcardActiveFalse, changeEcardActiveTrue, pageLoaded, pageLoading } from '../../../actions'
import styles from './BuyCards.module.css'
import { UClick } from '../../../components/common/utils'

const ChanghuanPopup = ({ visible, setVisible, toPay, hasChanghuanRights }) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [selectedCerts, setSelectedCerts] = useState([])
  const { loading } = useGetVipEcardsReplacementOptions({
    manual: false,
    onSuccess: (data) => {
      const standardCard = { desc: '普通版', imgFile: 'cert_161.jpg' }
      if (data.images) {
        const filteredImages = data.images.filter((img) => !img.desc.startsWith('生肖卡'))
        setOptions([...filteredImages, standardCard])
      } else {
        setOptions([standardCard])
      }
    },
  })
  const { run: bindEcards } = useBindingEcards({
    onSuccess: (data) => {
      if (data) {
        showToast('卡面更换成功！')
        dispatch(changeEcardActiveTrue(data))
      }
    },
    onFinally: () => {
      dispatch(pageLoaded())
    },
  })

  const { run: cancelBindEcards } = useCancelBindingEcards({
    onSuccess: (data) => {
      if (data) {
        showToast('卡面更换成功！')
        dispatch(changeEcardActiveFalse(data))
      }
    },
    onFinally: () => {
      dispatch(pageLoaded())
    },
  })
  const { ecards, profile, userInfo } = useSelector((state) => ({
    profile: getProfile(state),
    ecards: getEcards(state),
    userInfo: getUserInfo(state),
  }))

  const toPayEquity = () => {
    UClick('clickBuyBtn-buy-page')
    setVisible(false)
    toPay()
  }

  const toggleCert = (ecard) => {
    const hasCurrentCert = selectedCerts.find((cert) => cert.ecardId === ecard.encodedId)
    if (options[selectedIndex].desc === '普通版') {
      if (!hasCurrentCert) {
        setSelectedCerts([...selectedCerts, { ecardId: getAffiliateId(ecard) }])
      } else {
        setSelectedCerts(selectedCerts.filter((c) => c.ecardId !== getAffiliateId(ecard)))
      }
    } else {
      const hasBindEcard = options[selectedIndex].bindEcards.find((card) => card.ecardId === ecard.encodedId)
      if (!hasBindEcard) {
        showToast('您当前选择的证书并无该卡面，请重新选择。', false)
        return
      }
      if (!hasCurrentCert) {
        const currentEcard = options[selectedIndex].bindEcards
        const findSelectedEcard = currentEcard.find((item) => item.ecardId === getAffiliateId(ecard))
        setSelectedCerts([...selectedCerts, findSelectedEcard])
      } else {
        setSelectedCerts(selectedCerts.filter((c) => c.ecardId !== getAffiliateId(ecard)))
      }
    }
  }

  const changeImage = (index) => {
    setSelectedCerts([])
    setSelectedIndex(index)
  }

  const getAffiliateId = (ecard) => {
    return ecard.affiliateCertificationId || ecard.affiliateCredentialId
  }

  const bindingCards = () => {
    if (selectedCerts.length === 0) {
      showToast('请选择您要更换卡面的证书。', false)
      return
    }
    const currentImg = options[selectedIndex]
    dispatch(pageLoading())
    if (currentImg.desc === '普通版') cancelBindEcards(selectedCerts)
    else bindEcards(selectedCerts)
  }

  const getImgSrc = () => {
    const currentItem = options[selectedIndex]
    return getCardFaceImageUrl(currentItem.imgFile, currentItem.desc)
  }

  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        setVisible(false)
      }}
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      }}
    >
      {options.length > 0 && (
        <div className={styles['changhuan-popup']}>
          <div className={styles.top}>
            <h1 className={styles['card-name']}>{options[selectedIndex].desc}</h1>
            <img src={getImgSrc()} className={styles.img} />
            <h4 className={styles['type-title']}>卡面选择</h4>
            <div className={styles.tags}>
              {options.map((item, index) => (
                <Tag key={index} selected={index === selectedIndex} onClick={() => changeImage(index)}>
                  {item.desc}
                </Tag>
              ))}
            </div>
            <h4 className={styles['type-title']}>证书选择</h4>
            <div className={styles['certs-tags']}>
              {ecards.map((item, index) => (
                <Tag
                  key={index}
                  selected={!!selectedCerts.find((c) => c.ecardId === getAffiliateId(item))}
                  onClick={() => toggleCert(item)}
                >
                  {item.credentialName || item.certificationName}
                </Tag>
              ))}
            </div>
          </div>
          <div className={styles.bottom}>
            {hasChanghuanRights ? (
              <button className={styles['light-btn']} onClick={bindingCards}>
                立即使用
              </button>
            ) : (
              <button className={styles['light-btn']} onClick={toPayEquity}>
                <span>立即购买</span>
                <span className={styles.price}>￥99</span>
              </button>
            )}
            <button className={styles['cancel-btn']} onClick={() => setVisible(false)}>
              取消
            </button>
          </div>
        </div>
      )}
    </Popup>
  )
}

export default ChanghuanPopup
